<template>
  <Modal
    extra-class="dea-modal--date dea-modal--no-footer"
    :has-full-width="modalFullWidth"
    :visible="visible"
    @modal-close="$emit('modal-close')"
  >
    <template v-if="user.parent_id" #title>
      {{ titleLabel }} la data di nascita di {{ user.firstname }} {{ user.lastname }}
    </template>
    <template v-else #title> {{ titleLabel }} la tua data di nascita </template>
    <template #content>
      <div class="dea-heading--medium-m dea-modal-create-student__section-title">Data di nascita</div>
      <DateSelect
        :need-check="checkDate"
        :user="user"
        @check-needed="checkDate = false"
        @user-update="$emit('user-update', $event)"
      />
      <Buttons class="dea-button--large" @click="checkDate = true">Salva modifiche</Buttons>
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";
import variables from "@/styles/variables.scss";
import windowResize from "@/components/mixins/handleWindowResize";
import DateSelect from "~/components/myProfile/components/DateSelect";
import getBirthDate from "../helpers/getBirthDate";

export default {
  name: "DateModal",
  components: { Buttons, DateSelect, Modal },
  mixins: [windowResize],
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkDate: false,
      titleLabel: "",
    };
  },
  computed: {
    modalFullWidth() {
      return this.windowWidth <= variables.bpSizeSmall;
    },
  },
  mounted() {
    const { day, month, year } = this.getBirthDate(this.user.birth_day, this.user.birth_month, this.user.birth_year);
    const birthDate = `${year}-${month}-${day}`;
    this.titleLabel = birthDate !== "null-null-null" ? "Modifica" : "Aggiungi";
  },
  methods: {
    getBirthDate,
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$input-wrapper-width: 330px;
$input-height: 40px;

.dea-modal {
  &__date-label {
    margin-bottom: $space-x-small;
    text-transform: uppercase;
  }
}
</style>
